export const StartSettingsRoute = {
  path: '/start_settings',
  meta: { requiresAuth: true },
  component: () => import('layouts/MainLayout.vue'),
  children: [
    {
      path: '',
      name: 'startSettings',
      component: () => import('pages/startSettings/IndexPage.vue'),
      meta: {
        requiresAuth: true,
        title: '開始設定一覧',
        path: '/start_settings',
        condition: 'startSetting',
      },
    },
    {
      path: ':id',
      name: 'startSettings-id',
      component: () => import('src/pages/startSettings/id/IndexPage.vue'),
      meta: {
        requiresAuth: true,
        title: ':name',
        parents: [
          {
            title: '開始設定一覧',
            path: '/start_settings',
            condition: 'startSetting',
          },
        ],
      },
    },
    {
      path: ':id/edit',
      name: 'startSettings-id-edit',
      component: () => import('src/pages/startSettings/id/EditPage.vue'),
      meta: {
        requiresAuth: true,
        title: ':name',
        parents: [
          {
            title: '開始設定一覧',
            path: '/start_settings',
            condition: 'startSetting',
          },
          {
            title: ':name',
            path: '/start_settings/:id',
          },
        ],
      },
    },
  ],
};
